module.exports = __webpack_public_path__ + "assets/simpl.a0532d342d5b55f7147b63afbc710b79.svg";